import type { SVGProps } from 'react';

const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      clipRule='evenodd'
      d='M6.544 8.087a5.337 5.337 0 1 1 10.674 0v2.093c0 .712.23 1.348.504 1.897.192.384.432.774.647 1.122.08.13.158.256.227.372.23.384.36.833.36 1.314 0 1.246-.885 2.29-2.085 2.455-1.57.218-3.498.432-4.99.432s-3.42-.214-4.99-.431c-1.2-.167-2.086-1.21-2.086-2.456 0-.481.131-.93.36-1.314l.228-.372c.215-.348.455-.738.647-1.122.274-.55.504-1.185.504-1.897V8.087ZM11.88 1.25a6.837 6.837 0 0 0-6.837 6.837v2.093c0 .387-.125.783-.346 1.227-.16.32-.344.618-.544.942-.09.145-.182.295-.277.454a4.054 4.054 0 0 0-.572 2.082c0 1.96 1.404 3.667 3.38 3.941 1.582.22 3.595.446 5.196.446 1.6 0 3.613-.226 5.196-.446 1.976-.274 3.38-1.981 3.38-3.94 0-.76-.209-1.473-.572-2.083-.096-.16-.188-.31-.277-.454-.2-.324-.384-.622-.544-.942-.222-.444-.346-.84-.346-1.227V8.087A6.837 6.837 0 0 0 11.88 1.25Zm1.55 19.167a.75.75 0 1 1 1.248.83 3.356 3.356 0 0 1-5.597 0 .75.75 0 1 1 1.25-.83c.334.503.903.831 1.549.831.646 0 1.215-.328 1.55-.831Z'
      fill='currentColor'
      fillRule='evenodd'
    />
  </svg>
);
export default SvgBell;
